/**
 * URL Utils
 */

export function encodeForUrl(payload: any) {
  return btoa(JSON.stringify(payload));
}
export function decodeFromUrl<R = any>(payload: string | null): R {
  return payload != null ? JSON.parse(atob(payload)) : null;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/url.ts